'use client';

import { ReactNode } from 'react';
import {
  DrawerHeader,
  DrawerBody,
  useDrawer,
  Conditional
} from '@cat-ecom/pcc-components';
import {
  CatButton,
  CatHeading,
  CatIconChevronRight,
  CatDrawer
} from 'components/blocks-components';
import styles from '../anchor-menu-mobile.module.scss';

export interface AnchorMenuMobileSectionHeaderProps {
  titleText: string;
  children?: ReactNode;
  shouldShowButton?: boolean;
}

const AnchorMenuMobileSectionHeader = ({
  titleText,
  shouldShowButton = true,
  children
}: AnchorMenuMobileSectionHeaderProps) => {
  const { drawerProps, openDrawer } = useDrawer();

  return (
    <div>
      <div className="d-flex justify-content-between">
        <CatHeading className="d-flex align-items-center" variant="title-sm">
          {titleText}
        </CatHeading>
        <Conditional test={shouldShowButton}>
          {
            <CatButton
              hideText
              onClick={openDrawer}
              data-testid="cat-open-drawer-button"
            >
              <CatIconChevronRight slot="before" />
            </CatButton>
          }
        </Conditional>
      </div>
      <CatDrawer
        {...drawerProps}
        orientation="bottom"
        className={styles['anchor-menu-mobile__section-header-drawer']}
        data-testid="anchor-mobile-drawer"
        verticalMaxHeight="large"
      >
        <DrawerHeader className="d-flex justify-content-between">
          <CatHeading variant="title-sm">{titleText}</CatHeading>
        </DrawerHeader>
        <DrawerBody>{children}</DrawerBody>
      </CatDrawer>
    </div>
  );
};

export default AnchorMenuMobileSectionHeader;
